
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  props: {
    graphData: Object,
    chartHeight: String,
    account: Object,
  },

  setup(props) {
    const total = "1.8M";
    const chartOptions = {
      chart: {
        type: "donut",
      },
      grid: {
        padding: {
          left: 0,
        },
      },
      labels: [
        "Aceitaram Todos",
        "Personalizados",
        "Visualizações",
        "Consentimentos",
      ],
      colors: ["#20D489", "#FFA800", "#00A3FF", "#FFCF00"],
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
    };
    const series = ref(false) as any;
    onMounted(async () => {
      series.value = [
        props?.account?.stats.all,
        props?.account?.stats.custom,
        props?.account?.stats.views,
        props?.account?.stats.consents,
      ];
    });

    return {
      total,
      chartOptions,
      series,
    };
  },
  computed: {
    percentage() {
      if (!this.account) return 0;
      return Math.round(
        (this.account?.stats.all / this.account?.stats.consents) * 100
      );
    },
  },
});
